import { BaseStore } from "@infrastructure/stores/_base.store";
import { PromoCode } from "@infrastructure/clients/http/clients/promo.client";

type PromoStoreState = {
  promoList: PromoCode[];
  activePromo: PromoCode | null;
};

class PromoStoreFactory extends BaseStore<PromoStoreState> {
  promoList: PromoCode[] = [];
  activePromo: PromoCode | null = null;

  constructor() {
    super();
  }

  protected createState(): PromoStoreState {
    return {
      promoList: this.promoList,
      activePromo: this.activePromo,
    };
  }

  protected getStateKey(): string {
    return `promo:${this.activePromo?.code || "none"}:${this.promoList.length}`;
  }

  /**
   * Устанавливает список промокодов
   */
  setPromoList(promos: PromoCode[]) {
    this.promoList = promos;
    this.notifyListeners();
  }

  /**
   * Устанавливает активный промокод
   */
  setActivePromo(promo: PromoCode | null) {
    this.activePromo = promo;
    this.notifyListeners();
  }
}

export const PromoStore = new PromoStoreFactory();

